import { useChangeActions } from "./useChangeActions.js";
import { useFocusActions } from "./useFocusActions.js";
import { useKeyboardActions } from "./useKeyboardActions.js";
import { useMouseActions } from "./useMouseActions.js";
function useActions(params) {
  const {
    updateComponentState,
    allowUnlistedValues,
    componentState,
    timeFormat,
    allowEmpty,
    disabled,
    options,
    inputRef
  } = params;
  const mouseActions = useMouseActions(componentState, updateComponentState, disabled, inputRef);
  const focusActions = useFocusActions({
    updateComponentState,
    allowUnlistedValues,
    componentState,
    allowEmpty,
    timeFormat,
    options
  });
  const keyboardActions = useKeyboardActions({
    onBlur: focusActions.onBlur,
    updateComponentState,
    allowUnlistedValues,
    componentState,
    timeFormat,
    options,
    allowEmpty
  });
  const changeActions = useChangeActions({
    updateComponentState,
    allowUnlistedValues,
    allowEmpty,
    timeFormat,
    options
  });
  return {
    keyboardActions,
    changeActions,
    mouseActions,
    focusActions
  };
}
export {
  useActions
};
//# sourceMappingURL=useActions.js.map
